import { avocado_min_weight } from "../../../Layers/constants";
import { createBarcodeFilter } from "../barcodeFilter";
import {
    baseConfig,
    default_location_config,
    headerLinks
} from "../constants";
import { RootConfigType } from "../constantsTyped";
import { AVOCADO_FRUIT } from "../fruitNames";

export const MehadrinISRConfig: RootConfigType = {
    ...baseConfig,

    summary_collapsed: false,
    default_fruit_type: AVOCADO_FRUIT,
    can_do_manual_check: true,
    default_location_config: { ...default_location_config, device_result_action: false },
    default_manual: true,
    indicate_soft_avocado_at_internal: false,
    suggest_color_stage: true,
    underweight: avocado_min_weight,
    default_location: "ripening",

    research_mode: false,
    invalidate_20x_firmness: false,

    headerMainLinks: [headerLinks.home, headerLinks.packinglist],
    headerSecondaryLinks: [headerLinks.packinglist, headerLinks.settings, headerLinks.logout],
    barcode_filter: createBarcodeFilter([
        // Regular expression to match a string consisting of exactly 20 digits
        // Get the last 9 digits as a group
        /^(?:\d{11})(\d{9})$/,
    ]),
};
